<template>
    <!-- start navigator -->
    <div class="container ps-lg-5 pe-lg-5 mt-1">
        <div class="row">
            <div class="
            col-12
            d-none d-lg-flex
            justify-content-between
            align-items-center
          ">
                <nav style="--bs-breadcrumb-divider: '>'" aria-label="breadcrumb">
                    <ol class="breadcrumb">
                        <li class="breadcrumb-item">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">หน้าแรก</router-link>
                        </li>
                        <li class="breadcrumb-item" aria-current="page">
                            <router-link class="text-decoration-none router-link"
                                to="/AgenteService">ข้อมูลยื่นคำร้อง</router-link>
                        </li>
                        <li class="breadcrumb-item router-link active">
                            ขอต่ออายุใบอนุญาต
                        </li>
                    </ol>
                </nav>
            </div>
        </div>
    </div>
    <!-- end navigator -->

    <div class="container-lg" v-if="isVerified">
        <div class="row">
            <!-- Left Menu -->
            <div class="col-left-menu">
                <div class="left-menu">
                    <ul class="d-none d-lg-block">
                        <Menu />
                    </ul>
                </div>
            </div>
            <!-- Left Menu -->

            <div class="
          col-left-menu
          d-flex d-lg-none
          border-bottom
          align-items-center
          border-bottom
          w-100
          ps-3
          pe-3
        " style="background-color: #f2f2f2">
                <div class="icon-back">
                    <router-link to="/AgenteService">
                        <img src="@/assets/images/arrow-blue.svg" class="w-100" />
                    </router-link>
                </div>

                <div class="title ps-md-3 ps-lg-3 d-block d-lg-none text-center w-100 font-family blue-1">
                    ขอต่ออายุใบอนุญาต
                </div>
            </div>

            <div class="col">

                <StepBar :steps="['ตรวจสอบข้อมูล', 'อัปโหลดเอกสาร', 'ยืนยันการทำรายการ', 'ชำระเงิน', 'เสร็จสิ้น']"
                    :current="0" />

                <div class="title d-none d-lg-block border-bottom font-family blue-1">
                    ขอต่ออายุใบอนุญาต
                </div>

                <!-- เอกสารที่ต้องเตรียม/ขั้นตอนการต่อใบอนุญาตเป็นตัวแทนประกันชีวิตออนไลน์ -->
                <div class="font-family-bla my-3">
                    <div id="carouselExampleDark" class="carousel carousel-dark slide carousel-border"
                        data-bs-ride="false" data-bs-interval="false" ref="carousel">
                        <div class="carousel-indicators">
                            <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="0"
                                :class="{ active: activeIndex === 0 }" aria-label="Slide 1"></button>
                            <button type="button" data-bs-target="#carouselExampleDark" data-bs-slide-to="1"
                                :class="{ active: activeIndex === 1 }" aria-label="Slide 2"></button>
                        </div>
                        <div class="carousel-inner">
                            <div class="carousel-item" :class="{ active: activeIndex === 0 }">
                                <div class="d-block w-100 p-4 text-dark" style="min-height: 300px;">
                                    <h4 class="text-center">
                                        <b>เอกสารที่ต้องเตรียม</b>
                                    </h4>
                                    <ol class="fs-5">
                                        <li>หนังสือรับรองผ่านการอบรมหลักสูตรขอต่ออายุใบอนุญาตเป็นตัวแทนประกันชีวิต
                                            (วุฒิบัตร)</li>
                                        <li>รูปถ่ายหน้าตรงใช้ติดบัตร <br>
                                            <small> ข้อกำหนด: ไม่สวมแว่นกันแดด
                                                พื้นหลังไม่มีลวดลาย
                                                ไม่ยิ้มเห็นฟัน ไม่ใส่หมวก ไฟล์นามสกุล .JPG ขนาด 1 นิ้ว – 1.5 นิ้ว
                                                (300x300
                                                DPI)</small>
                                        </li>
                                    </ol>
                                </div>
                            </div>
                            <div class="carousel-item" :class="{ active: activeIndex === 1 }">
                                <div class="d-block w-100 p-4 text-dark" style="min-height: 300px;">
                                    <h4 class="text-center">
                                        <b>ขั้นตอนการต่อใบอนุญาตเป็นตัวแทนประกันชีวิตออนไลน์</b>
                                    </h4>
                                    <ol class="fs-5">
                                        <li>ตรวจสอบข้อมูลผู้ยื่นคำร้องขอต่ออายุใบอนุญาตเป็นตัวแทนประกันชีวิต</li>
                                        <li>อ่านรายละเอียดคุณสมบัติและรับรองคุณสมบัติ</li>
                                        <li>อัปโหลดเอกสาร</li>
                                        <li>ตรวจสอบคำขอต่ออายุใบอนุญาตเป็นตัวแทนประกันชีวิต (ฉบับร่าง)</li>
                                        <li>ยืนยันการทำรายการ ผ่านรหัส OTP (One Time Password)</li>
                                        <li>ชำระเงินผ่าน QR Code (กรณีสมัครโครงการพิเศษ จะไม่มีขั้นตอนนี้)</li>
                                        <li>บริษัทตรวจสอบเอกสาร</li>
                                        <li>บริษัทแจ้งสถานะการส่งคำร้อง ผ่านทางอีเมลที่ให้ไว้กับบริษัทและแอปพลิเคชัน
                                            Easy Click</li>
                                    </ol>
                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- ปุ่มถัดไป -->
                    <div class="text-end mt-4">
                        <button class="btn btn-bla w-25" @click="handleNext">
                            {{ activeIndex < maxSlide ? 'ถัดไป' : 'ดำเนินการต่อ' }} </button>
                    </div>
                </div>

            </div>

        </div>
    </div>

    <div v-if="this.Loading">
        <LoadingBs5></LoadingBs5>
    </div>
</template>

<script>
import Menu from "@/components/agenteservice/Menu.vue";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";

import LoadingBs5 from "@/components/frontend/LoadingBs5";
import http from "@/services/AuthService";
import Swal from 'sweetalert2/src/sweetalert2.js'
import bootstrap from 'bootstrap/dist/js/bootstrap.bundle.min.js'; // ต้องใช้ bundle!

import StepBar from "@/components/agenteservice/StepBar.vue";

import '@/styles/SweetAlert2CustomCSS.css';

export default {
    name: "AgentRenewLicense",
    components: {
        Menu,
        LoadingBs5,
        StepBar
    },
    data() {
        return {
            faCircleXmark: faCircleXmark,
            Loading: true,
            activeIndex: 0,
            maxSlide: 1, // จำนวนสไลด์ - 1
            isVerified: false, // ยังไม่ผ่านการเช็ค
            steps: ['ตรวจสอบข้อมูล', 'อัปโหลดเอกสาร', 'ยืนยันการทำรายการ', 'ชำระเงิน', 'เสร็จสิ้น']
        };
    },
    mounted() {
        if (this.$store.state.AgentCode == '') {
            this.$router.push('/');
        }

        this.Authorization();

        this.checkLicenseNearExpiry();// ตรวจสอบว่ามีสิทธิ์ต่ออายุหรือไม่

    },
    methods: {
        checkLicenseNearExpiry() {
            this.Loading = true;

            // Call Api : ตรวจสอบว่ามีสิทธิ์ต่ออายุหรือไม่
            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get(`AgencyERequest/CanRequestLicenseRenewal`, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                this.Loading = false;

                if (response.status === 200) {
                    if (!response.data.isCanRequest) {
                        Swal.fire({
                            icon: "error",
                            title: "คำเตือน",
                            html: `ท่านไม่สามารถดำเนินการต่อไปได้ เนื่องจากเกินกำหนดระยะเวลาในการยื่นคำร้องขอต่ออายุใบอนุญาตฯ ออนไลน์ 
                                    <br>กรุณาติดต่อส่วนสัญญาตัวแทน อีเมล: <a href="mailto:agentcontract@bangkoklife.com">agentcontract@bangkoklife.com</a>
                                    <br>โทรศัพท์ : 02-777-8560, 8567
                                    <br>(ในเวลาทำการ จันทร์-ศุกร์ เวลา 08:30-17:00 น.)`,
                            // confirmButtonText: "ปิด",
                            allowOutsideClick: false,
                            allowEscapeKey: false,
                            allowEnterKey: false,
                            width: "auto", // ปล่อยให้ auto ไปก่อน
                            customClass: {
                                popup: 'swal-wide',
                                confirmButton: 'btn-bla btn-pill'
                            }
                        }).then(() => {
                            // เปลี่ยนไปหน้าเลือกเมนู
                            this.$router.replace('/AgenteService');
                        });
                    } else {
                        if (response.data.renewal === 4 &&
                            response.data.overdueResulPayment === "Y" &&
                            Array.isArray(response.data.listOverdue) &&
                            response.data.listOverdue.length > 0) {
                            const overdueHtml = response.data.listOverdue
                                .map(item => `
                                    <div style="display: flex;">
                                        <span style="margin-right: 8px;">-</span>
                                        <span>${item}</span>
                                    </div>`)
                                .join('');

                            Swal.fire({
                                icon: "error",
                                title: "คำเตือน",
                                html: `
                                        <!-- ข้อความบน (ตรงกลาง + ย่อหน้า) -->
                                        <div style=" text-align: center;margin-bottom: 10px;">
                                            ท่านไม่สามารถดำเนินการต่อไปได้ เนื่องจากมีรายการค้างชำระ ดังนี้ 
                                            กรุณาดำเนินการที่ระบบ Bangkok Life Training
                                        </div>

                                        <!-- รายการด้านล่าง (ชิดซ้าย) -->
                                        <div style="text-align: left; font-size: 19px; line-height: 1.7;">
                                        ${overdueHtml}

                                        </div>
                                `,
                                allowOutsideClick: false,
                                allowEscapeKey: false,
                                allowEnterKey: false,
                                width: "auto", // ปล่อยให้ auto ไปก่อน
                                customClass: {
                                    popup: 'swal-wide ul-swal',
                                    confirmButton: 'btn-bla btn-pill'
                                }
                            }).then(() => {
                                this.$router.replace('/AgenteService');
                            });

                        } else {
                            this.$store.state.AgentRenewLicense.CanRequestLicenseRenewal = response.data;

                            // :: call api CheckAgentRenewLicenseServiceJob ::
                            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
                            http.get(`AgencyERequest/CheckAgentRenewLicenseServiceJob`, { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                            }).catch((error) => {
                                Swal.fire({
                                    icon: 'error',
                                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                                });
                            });
                            // :: call api CheckAgentRenewLicenseServiceJob ::

                            this.isVerified = true;
                            this.BindingData();  // เรียก BindingData หลัง isVerified = true
                        }

                    }
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        html: '<label class="fs-4 fw-normal font-family">ไม่สามารถดำเนินการได้ กรุณาลองใหม่อีกครั้ง</label>',
                    });
                }
            }).catch((error) => {
                this.Loading = false;
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            });
        },
        nextSlide() {
            const carousel = new bootstrap.Carousel(this.$refs.carousel);
            carousel.next();
        },
        prevSlide() {
            if (this.activeIndex > 0) {
                const carousel = new bootstrap.Carousel(this.$refs.carousel);
                carousel.prev();
            }
        },
        async handleNext() {
            const canProceed = await this.Authentication('L01');
            if (!canProceed) {
                return; // หยุดการทำงานถ้ามีเอกสารอยู่แล้ว
            }

            if (this.activeIndex < this.maxSlide) {
                this.nextSlide();
                this.activeIndex++;
            } else {
                // ดำเนินการต่อเมื่ออยู่หน้าสุดท้าย
                this.goNext();
            }
        },
        goNext() {
            //PreviewAgentRenewLicense

            this.$router.replace('/PreviewAgentRenewLicense');
        },
        ResetState() {

            this.BindingData();
        },
        async Authentication(SUBJOB) {
            try {
                const AuthorizeToken = localStorage.getItem("AuthorizeToken");
                const request = {
                    AGENTCODE: [],
                    SUBJOB: SUBJOB
                };

                const res = await http.post("AgencyERequest/CheckCreateJob?", request, { headers: { Authorization: `Bearer ${AuthorizeToken}` } });

                if (res.data === '001' || res.data === '002') {
                    Swal.fire({
                        icon: 'error',
                        html: '<label class="fs-4 fw-normal font-family">ไม่สามารถทำรายการนี้ได้ เนื่องจากมีการร้องของานไปแล้วก่อนหน้า</label>',
                    }).then(() => {
                        this.$router.replace('/AgenteService');
                    });
                    return false; // มีเอกสารอยู่แล้ว
                }

                console.log('ยังไม่มีเอกสารที่สร้างไปก่อนหน้า');
                return true; // สามารถดำเนินการต่อได้

            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">เกิดข้อผิดพลาดของระบบ</label>',
                }).then(() => {
                    this.$router.replace("/AgenteService");
                });
                return false; // ไม่สามารถดำเนินการต่อได้
            }
        },
        Authorization() {
            this.Loading = true;

            let AuthorizeToken = localStorage.getItem("AuthorizeToken");
            http.get("AgencyERequest/GetName", { headers: { Authorization: `Bearer ${AuthorizeToken}` } }).then((response) => {
                if (response.status == 200) {
                    this.Loading = false;

                    this.$store.state.UserName = response.data.NAME + " " + response.data.SURNAME;
                    this.$store.state.AgentCode = response.data.AGENTCODE;
                }
                else {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor", '_self');
                }
            }).catch((error) => {
                Swal.fire({
                    icon: 'error',
                    html: '<label class="fs-4 fw-normal font-family">' + error.response.data.ErrorMessage + '</label>',
                }).then(() => {
                    localStorage.removeItem("Token");
                    localStorage.removeItem("AuthorizeToken");
                    window.open(process.env.VUE_APP_URL_ADFS + "AgencyERequestConvertor/Logout", '_self');
                });
            });
        },
        BindingData() {
            if (this.isVerified) {
                this.$nextTick(() => {
                    const carouselEl = document.getElementById("carouselExampleDark");
                    if (carouselEl) {
                        carouselEl.addEventListener("slid.bs.carousel", (event) => {
                            this.activeIndex = event.to;
                        });
                    }
                });
            }

        },
        ChechCreateJob(to) {
            this.Authorization();
            this.$router.push(to);
        },
    },
};

</script>

<style scoped>
.custom-btn-width {
    width: 100% !important;
    min-width: 150px;
    max-width: 300px;
}

.carousel-border {
    border: 2px solid #A2B9E2;
    border-radius: 10px;
}

.carousel-inner {
    border: 1px solid #dee2e6;
    border-radius: 8px;
}

.font-family-bla {
    font-family: "DB Heavent";
}
</style>